import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyMobile = () => {
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate('/home');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="otp" className="block text-gray-700">Enter OTP</label>
            <input type="text"id="otp"value={otp}onChange={(e) => setOtp(e.target.value)}className="w-full p-2 border rounded-md"required/>
          </div>
          <button type="submit" className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-700">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyMobile;
